import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OrderlistComponent } from './orderlist.component';
import { AuthGuard } from '../../shared/auth/auth-guard.service';



const routes: Routes = [
  {
    path: '',
     component: OrderlistComponent,
    data: {
      title: 'orderlist'
    },    
    canActivate: [AuthGuard] 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrderListRoutingModule { }